import DesktopContent from './DesktopContent'

export default DesktopContent
